import { render, staticRenderFns } from "./QrCodeMessageBox.vue?vue&type=template&id=04b33846"
import script from "./QrCodeMessageBox.vue?vue&type=script&lang=js"
export * from "./QrCodeMessageBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports